import Http from 'services/Http';

const BATCH_DELAY_MS = 75;
const MAX_BATCH_SIZE = 30;

let queue = [];
let flushTimer = null;
let inflightFlush = null;

export const parseUrlPreviewPayload = data => {
  if (!data || typeof data !== 'object') {
    return null;
  }
  if (data._error) {
    return null;
  }
  if (!data.title) {
    return null;
  }
  return data;
};

async function runFlush() {
  const batch = queue;
  queue = [];

  const waitersByUrl = new Map();
  for (const item of batch) {
    const existing = waitersByUrl.get(item.url);
    if (existing) {
      existing.push(item);
    } else {
      waitersByUrl.set(item.url, [item]);
    }
  }

  const urls = [...waitersByUrl.keys()];
  const chunks = [];
  for (let i = 0; i < urls.length; i += MAX_BATCH_SIZE) {
    chunks.push(urls.slice(i, i + MAX_BATCH_SIZE));
  }

  try {
    for (const chunk of chunks) {
      const response = await Http.post('/v1/preview/batch', { urls: chunk });
      const payload = response?.data && typeof response.data === 'object' ? response.data : {};

      for (const url of chunk) {
        const previewData = parseUrlPreviewPayload(payload[url]);
        const waiters = waitersByUrl.get(url) || [];
        for (const waiter of waiters) {
          waiter.resolve(previewData);
        }
      }
    }
  } catch (error) {
    for (const waiters of waitersByUrl.values()) {
      for (const waiter of waiters) {
        waiter.reject(error);
      }
    }
  }
}

function scheduleFlush() {
  if (flushTimer) {
    return;
  }
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushQueue();
  }, BATCH_DELAY_MS);
}

async function flushQueue() {
  if (inflightFlush) {
    await inflightFlush;
  }
  if (queue.length === 0) {
    return;
  }

  inflightFlush = runFlush();
  try {
    await inflightFlush;
  } finally {
    inflightFlush = null;
  }

  if (queue.length > 0) {
    scheduleFlush();
  }
}

/**
 * Queue a URL preview fetch; requests within BATCH_DELAY_MS share one batch HTTP call.
 */
export const fetchUrlPreviewBatched = url =>
  new Promise((resolve, reject) => {
    queue.push({ url, resolve, reject });
    scheduleFlush();
  });
